import { ChangeDetectorRef, Component, Inject, Input, OnDestroy } from '@angular/core';
import { CorrespondenceAttachmentInterface } from '@app/core/interfaces/correspondence-attachment.interface';
import { WINDOW } from '@inshared/shared/util';
import { DamageClaimService } from '@app/my-zone/pages/claims/damage-claim/damage-claim.service';
import { DownloadingModalComponent } from '@app/shared/modals/downloading/downloading-modal.component';
import { PdfDownloadUtilities } from '@app/shared/utilities/pdf-download-utilities';
import { NewModal } from 'outshared-lib';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ins-photo-download',
    templateUrl: './photo-download.component.html',
})
export class PhotoDownloadComponent implements OnDestroy {

    @Input() documentId: string;

    public loading: boolean = false;

    private subscriptions = new Subscription();

    constructor(
        private _service: DamageClaimService,
        private newModal: NewModal,
        private changeDetectorRef: ChangeDetectorRef,
        @Inject(WINDOW) private window: Window
    ) {}

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    public onDownloadClick(): void {
        this.loading = true;

        const modalRef = this.newModal.open(DownloadingModalComponent);

        const correspondenceSubscription = this._service.getCorrespondence(this.documentId)
            .subscribe(
                (attachment: CorrespondenceAttachmentInterface) => {
                    modalRef.close();
                    this.loading = false;
                    this.changeDetectorRef.detectChanges();
                    this.openPdfModal(attachment);
                }, () => {
                    modalRef.close();
                    this.loading = false;
                    this.changeDetectorRef.detectChanges();
                },
            );
        this.subscriptions.add(correspondenceSubscription);
    }

    private openPdfModal(attachment: CorrespondenceAttachmentInterface): void {
        PdfDownloadUtilities.OpenPdfBase64TargetBlank(attachment.data_base64, attachment.mime_type, this.window);
    }
}
